
import { TermDepositListState } from "../types";
import { expiringTermDepositsSlice } from "./slice";
import { combineReducers } from '@reduxjs/toolkit';

export type TermDepositState = {
  list: TermDepositListState;
};
 
export const termDepositReducer = combineReducers<TermDepositState>({
  list: expiringTermDepositsSlice.reducer,
});
